import React from "react";
import { PageIntroWrapper } from "./styles";

interface PageIntroProps {
	title: string;
	children: React.ReactNode;
}

const PageIntro = ({ title, children }: PageIntroProps) => (
	<PageIntroWrapper>
		<h1>{title}</h1>
		<div className={"accent"} />
		<p>{children}</p>
	</PageIntroWrapper>
);

export default PageIntro;
